"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSThemeSwitch = /** @class */ (function (_super) {
    __extends(HSThemeSwitch, _super);
    function HSThemeSwitch(el, options) {
        var _this = _super.call(this, el, options) || this;
        var data = el.getAttribute('data-hs-theme-switch');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.theme =
            (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.theme) || localStorage.getItem('hs_theme') || 'default';
        _this.themeSet = ['light', 'dark', 'default'];
        _this.init();
        return _this;
    }
    HSThemeSwitch.prototype.init = function () {
        this.createCollection(window.$hsThemeSwitchCollection, this);
        if (this.theme !== 'default')
            this.setAppearance();
    };
    HSThemeSwitch.prototype.setResetStyles = function () {
        var style = document.createElement('style');
        style.innerText = "*{transition: unset !important;}";
        style.setAttribute('data-hs-appearance-onload-styles', '');
        document.head.appendChild(style);
        return style;
    };
    HSThemeSwitch.prototype.addSystemThemeObserver = function () {
        var _this = this;
        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', function (_a) {
            var matches = _a.matches;
            if (matches)
                _this.setAppearance('dark', false);
            else
                _this.setAppearance('default', false);
        });
    };
    HSThemeSwitch.prototype.removeSystemThemeObserver = function () {
        window.matchMedia('(prefers-color-scheme: dark)').removeEventListener;
    };
    // Public methods
    HSThemeSwitch.prototype.setAppearance = function (theme, isSaveToLocalStorage, isSetDispatchEvent) {
        if (theme === void 0) { theme = this.theme; }
        if (isSaveToLocalStorage === void 0) { isSaveToLocalStorage = true; }
        if (isSetDispatchEvent === void 0) { isSetDispatchEvent = true; }
        var html = document.querySelector('html');
        var resetStyles = this.setResetStyles();
        if (isSaveToLocalStorage)
            localStorage.setItem('hs_theme', theme);
        if (theme === 'auto')
            theme = window.matchMedia('(prefers-color-scheme: dark)').matches
                ? 'dark'
                : 'default';
        html.classList.remove('light', 'dark', 'default', 'auto');
        html.classList.add(theme);
        setTimeout(function () { return resetStyles.remove(); });
        if (isSetDispatchEvent)
            window.dispatchEvent(new CustomEvent('on-hs-appearance-change', { detail: theme }));
    };
    // Static methods
    HSThemeSwitch.getInstance = function (target) {
        var elInCollection = window.$hsThemeSwitchCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection ? elInCollection.element : null;
    };
    HSThemeSwitch.autoInit = function () {
        if (!window.$hsThemeSwitchCollection)
            window.$hsThemeSwitchCollection = [];
        var toggleObserveSystemTheme = function (el) {
            if (localStorage.getItem('hs_theme') === 'auto')
                el.addSystemThemeObserver();
            else
                el.removeSystemThemeObserver();
        };
        document
            .querySelectorAll('[data-hs-theme-switch]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsThemeSwitchCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; })) {
                var switchTheme_1 = new HSThemeSwitch(el);
                switchTheme_1.el.checked =
                    switchTheme_1.theme === 'dark';
                toggleObserveSystemTheme(switchTheme_1);
                switchTheme_1.el.addEventListener('change', function (evt) {
                    var theme = evt.target.checked
                        ? 'dark'
                        : 'default';
                    switchTheme_1.setAppearance(theme);
                    toggleObserveSystemTheme(switchTheme_1);
                });
            }
        });
        document
            .querySelectorAll('[data-hs-theme-click-value]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            var theme = el.getAttribute('data-hs-theme-click-value');
            var switchTheme = new HSThemeSwitch(el);
            toggleObserveSystemTheme(switchTheme);
            switchTheme.el.addEventListener('click', function () {
                switchTheme.setAppearance(theme);
                toggleObserveSystemTheme(switchTheme);
            });
        });
    };
    return HSThemeSwitch;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSThemeSwitch.autoInit();
    // Uncomment for debug
    // console.log('Theme switch collection:', window.$hsThemeSwitchCollection);
});
if (window.$hsThemeSwitchCollection) {
    window.addEventListener('on-hs-appearance-change', function (evt) {
        window.$hsThemeSwitchCollection.forEach(function (el) {
            el.element.el.checked = evt.detail === 'dark';
        });
    });
}
if (typeof window !== 'undefined') {
    window.HSThemeSwitch = HSThemeSwitch;
}
exports.default = HSThemeSwitch;
